import script from "./DSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./DSwitch.vue?vue&type=script&setup=true&lang=js"

import "./DSwitch.vue?vue&type=style&index=0&id=d400499a&lang=scss"

const __exports__ = script;

export default __exports__